// extracted by css-extract-rspack-plugin
export default {"premium-selected":"CJB_LU","premiumSelected":"CJB_LU","price-input":"kpsg6v","priceInput":"kpsg6v","full-width":"G93XFZ","fullWidth":"G93XFZ"};